<script>
  import TaskDescription from "./TaskDescription.svelte";
  import TaskComments from "./TaskComments.svelte";
  import Redirect from "../../components/backDashboard.svelte";
  import { onMount, onDestroy } from "svelte";
  export let TaskRef;
  import { router } from "tinro";
  import { conversion, lang } from "../../store/store";
  import ApproveComponent from "../../components/approveDeclineTask.svelte";
  import { db, user } from "../../firebase";
  import { doc, getDoc } from "firebase/firestore";

  let data;
  onMount(async () => {
    let resp = await getDoc(
      doc(db, "/stores/" + user.auth.claims.store + "/secrets/protected")
    );
    data = resp.data();
    console.log(data);
  });

  let userTasks;
  let tasks;
  let userData;
  onMount(() => {
    $user.doc.subscribe((v) => {
      userData = v;
    });
    let vdata;
    const unsubscribeUser = $user.tasks.subscribe((v) => {
      vdata = v;
      tasks = vdata;
      if (Object.keys(tasks).length > 0) {
        if (tasks[TaskRef] == undefined) {
          router.goto("/", { replace: true });
          return;
        }
      }
      userTasks = JSON.parse(JSON.stringify(tasks));
      userTasks = userTasks[TaskRef];

      if (!v[TaskRef]) {
        return;
      }
    });
  });

  function handleClick() {}
  let title = $conversion[$lang].SingleTask.title;
</script>

<div class="contentWrapper">
  <div class="mainContent">
    <Redirect bind:title />
  </div>
  <!-- <h1 on:click={handleClick}>To add new Component</h1> -->
  <!-- {#if userTasks}{userTasks.name}{/if} -->
  {#if userTasks}
    <ApproveComponent bind:userTasks bind:data />
  {/if}
  <div class="TaskDetailsWrapper">
    <div class="TaskDetailsWrapper_left">
      {#if userTasks}
        <TaskDescription bind:userTasks {TaskRef} />
      {/if}
    </div>
    <div class="TaskDetailsWrapper_right">
      {#if userTasks}
        <TaskComments bind:userTasks {TaskRef} />
      {/if}
    </div>
  </div>
</div>

<style>
  * {
    padding: 0;
    margin: 0;
  }

  .contentWrapper {
    padding-bottom: 6rem;
    width: 95%;
    max-width: 1190px;
  }

  .TaskDetailsWrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
  }

  .TaskDetailsWrapper_left {
    background: white;
    width: 50%;
    margin-right: 15px;
    border-radius: 1.25rem;
    padding: 1rem;
  }

  .TaskDetailsWrapper_right {
    margin-left: 15px;
    background: white;
    width: 50%;
    border-radius: 1.25rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  @media only screen and (max-width: 1100px) {
    .TaskDetailsWrapper {
      flex-direction: column;
      align-items: center;
    }
    .TaskDetailsWrapper_left,
    .TaskDetailsWrapper_right {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      margin-top: 15px;
    }
  }
</style>
